<script setup>
// Facebook Reauthorize.vue — Fase 1.5 do plano
// .ai/messenger-integration-plan.md: único componente de reautorização
// (substitui os dois antigos, ambos quebrados — facebook/Reauthorize.vue via
// FB SDK e este, que chamava generateAuthorization()/rota inexistente).
// Reconectar é refazer o login OAuth (mesmo endpoint da conexão inicial) — o
// backend encontra o canal pelo facebook_id e atualiza, mesmo padrão do
// instagram/Reauthorize.vue.
import { ref } from 'vue';
import InboxReconnectionRequired from '../../components/InboxReconnectionRequired.vue';

import facebookClient from 'dashboard/api/channel/fbChannel';

import { useI18n } from 'vue-i18n';
import { toast } from 'dashboard/helper/toast';
import { metaAuthErrorMessage } from 'dashboard/helper/metaAuthError';

const { t } = useI18n();

const isRequestingAuthorization = ref(false);

async function requestAuthorization() {
  try {
    isRequestingAuthorization.value = true;
    const response = await facebookClient.createAuthorization();

    const {
      data: { url },
    } = response;

    window.location.href = url;
  } catch (error) {
    toast.error(metaAuthErrorMessage(error, t, 'INBOX_MGMT.ADD.FB'));
  } finally {
    isRequestingAuthorization.value = false;
  }
}
</script>

<template>
  <InboxReconnectionRequired
    class="mx-8 mt-5"
    @reauthorize="requestAuthorization"
  />
</template>
